module.exports = __webpack_public_path__ + "static/media/Lotus-picture-600.f9c267ae.jpg";